import { CalendarClock, MapPin, Truck } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { useSite } from "@/lib/SiteContext";

export default function DeliveryInfo() {
  const { site } = useSite();
  const c = site?.content?.delivery_info || {};
  return (
    <div className="mx-auto max-w-3xl px-4 py-12 sm:px-6 sm:py-16 lg:px-8" data-testid="delivery-info-page">
      <Reveal>
        <p className="text-xs font-bold uppercase tracking-[0.25em] text-gold">Delivery &amp; Collection</p>
        <h1 className="mt-3 font-serif text-3xl font-bold tracking-tight text-cream-text sm:text-4xl">
          {c.heading || "How getting your bakes works"}
        </h1>
      </Reveal>

      <div className="mt-10 space-y-6">
        <Reveal>
          <div className="rounded-3xl bg-cream p-6 text-cream-darktext sm:p-8" data-testid="info-deadline-card">
            <CalendarClock className="h-7 w-7 text-gold" aria-hidden="true" />
            <h2 className="mt-4 font-serif text-xl font-semibold">The weekly deadline: Wednesday, 6:00pm</h2>
            <p className="mt-2 text-sm leading-relaxed text-cream-darkmuted">
              {c.cutoff_text || "Everything is baked to order. Orders for each week's delivery and collection dates close at 6:00pm on the Wednesday beforehand. Miss the deadline? No problem — you can order for the following week straight away."}
            </p>
          </div>
        </Reveal>

        <Reveal>
          <div className="rounded-3xl bg-cream p-6 text-cream-darktext sm:p-8" data-testid="info-delivery-card">
            <Truck className="h-7 w-7 text-gold" aria-hidden="true" />
            <h2 className="mt-4 font-serif text-xl font-semibold">Local delivery</h2>
            <p className="mt-2 text-sm leading-relaxed text-cream-darkmuted">
              {c.delivery_text || "We deliver on either Saturday or Sunday morning — the delivery day is chosen and published each week, and the available slot is shown at checkout. Delivery to B96 is free with no minimum order. Delivery to B60, B61, B49, B50 and CV37 costs £5.00 with a £40.00 minimum order. Other postcodes may be available by request — please contact us. We don't currently offer nationwide shipping."}
            </p>
          </div>
        </Reveal>

        <Reveal>
          <div className="rounded-3xl bg-cream p-6 text-cream-darktext sm:p-8" data-testid="info-collection-card">
            <MapPin className="h-7 w-7 text-gold" aria-hidden="true" />
            <h2 className="mt-4 font-serif text-xl font-semibold">Collection — always free</h2>
            <p className="mt-2 text-sm leading-relaxed text-cream-darkmuted">
              {c.collection_text || "Choose a collection slot at checkout and we'll have your bakes boxed and ready. You can pay online in advance or select “pay on collection” and pay when you pick up."}
            </p>
          </div>
        </Reveal>
      </div>
    </div>
  );
}
